import addMinutes from "date-fns/addMinutes";
import parseISO from "date-fns/parseISO";
import getISODay from "date-fns/getISODay";
import { getStoreOption } from "@utils/ipetbooking-options";
import { HOME_TIME_LIST } from "@src/config/reservation";
import isAfter from 'date-fns/isAfter'
import isBefore from "date-fns/isBefore";
import isEqual from "date-fns/isEqual";
import addHours from 'date-fns/addHours'

export function reservationIsExpired({
  dateTime,
  storeAlias,
  beforehandOrder
} = {}) {
  const addBeforehandOrder = () => {
    const toDayDay = getISODay(new Date());
    const storeItem = getStoreOption({
      value: storeAlias,
      type: 'item'
    });

    return 0 - Number(beforehandOrder || storeItem?.params?.serviceTimeSetting[toDayDay]?.beforehandOrder) || 0
  };

  return isAfter(new Date(), addMinutes(parseISO(dateTime), addBeforehandOrder()))
}

export function reservationTimeList({
  date,
  storeAlias,
  times = [],
  session = 'all',
  startTime = '00:00',
  storeType = 'store'
} = {}) {
  return times.filter(time => {
    const [hour] = time.split(':');

    const isInSession = () => {
      switch(session) {
        case 'all':
          return true;
        case 'morning':
          return Number(hour) < 12;
        case 'afternoon':
          return Number(hour) <= 17 && Number(hour) >= 12;
        case 'night':
          return Number(hour) > 17;
      }
    };

    const isInHomeTimeList = () => {
      return !storeType || storeType === 'store' || (storeType === 'home' && HOME_TIME_LIST.includes(time));
    };

    const isAfterStartHour = () => {
      const [startHour] = startTime.split(':');

      return Number(startHour) <= Number(hour) || Number(startHour) === Number(hour)
    };

    const isExpired = reservationIsExpired({
      dateTime: `${date} ${time}`,
      storeAlias
    });

    return isInHomeTimeList() && isInSession() && isAfterStartHour() && !isExpired
  });
}

export function reservationTimeButtonList({
  date,
  start,
  lastOrder,
  storeType = 'store'
} = {}) {
  const hourList = storeType === 'store'
    ? Array.from({ length: 24 }).map((item, index) => {
      const time = index < 10 ? `0${index}` : `${index}`
      return {
        hour: time,
        minute: "00",
      }
    })
    : HOME_TIME_LIST.map(time => ({ hour: time.split(':')[0], minute: time.split(':')[1] }));

  return hourList
    .filter(({hour, minute}) => {
      const isAfterNow = isAfter(parseISO(`${date} ${hour}:${minute}`), addHours(new Date(), -1));
      const isAfterStart = () => {
        // const isAfterStart = isAfter(parseISO(`${date} ${hour}:${minute}`), parseISO(`${date} ${start}`));
        // const isEqualStart = isEqual(parseISO(`${date} ${hour}:${minute}`), parseISO(`${date} ${start}`));
        
        const isAfterStart = isAfter(parseISO(`${date} ${hour}`), parseISO(`${date} ${start.split(':')[0]}`));
        const isEqualStart = isEqual(parseISO(`${date} ${hour}`), parseISO(`${date} ${start.split(':')[0]}`));

        return isAfterStart || isEqualStart
      };

      const isBeforeEnd = () => {
        const isBeforeEnd = isBefore(parseISO(`${date} ${hour}:${minute}`), parseISO(`${date} ${lastOrder}`));
        const isEqualEnd = isEqual(parseISO(`${date} ${hour}:${minute}`), parseISO(`${date} ${lastOrder}`));

        return isBeforeEnd || isEqualEnd
      };

      return isAfterNow && isAfterStart() && isBeforeEnd()
    })
    .map(({hour, minute}) => `${hour}:${minute}`)
}
